module.exports = __webpack_public_path__ + "img/logo-smartBarcode.de9f5884.png";